import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../shared/NavBar';
import PageMetadata from '../../shared/PageMetadata';
import { PAGE_METADATA } from '../../pageMetadata';
import laptopMockup from '../../assets/laptop-mockup.png';
import { sportsClubAppPath, sportsClubAppTitle, sportsClubAppLead, sportsClubAppChecks, sportsClubAppFit, sportsClubAppTrial, sportsClubAppPlans, sportsClubAppChoose, sportsClubAppLinks } from './sportsClubAppContent';
import './SportsClubAppPage.css';

export default function SportsClubAppPage() {
  useEffect(() => {
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `https://www.shuttleops.com${sportsClubAppPath}`;
    document.head.appendChild(canonical);
    return () => canonical.remove();
  }, []);

  return <>
    <PageMetadata metadata={PAGE_METADATA[sportsClubAppPath]} />
    <header className="sports-app-hero">
      <NavBar />
      <div className="sports-app-intro">
        <div>
          <h1>{sportsClubAppTitle}</h1>
          <p>{sportsClubAppLead}</p>
          <Link className="sports-app-action" to="/test-club" data-test-club-cta="sports-app-hero">Try a free test club <span aria-hidden="true">→</span></Link>
          <small>Seven days. 10 fake players. No card or setup call.</small>
        </div>
        <img src={laptopMockup} alt="ShuttleOps Digital Peg Board showing a badminton session across four courts" />
      </div>
    </header>
    <main className="sports-app-main">
      <section className="sports-app-workflow" aria-labelledby="sports-app-workflow-title">
        <div><h2 id="sports-app-workflow-title">One club night, one connected flow</h2><p>{sportsClubAppFit}</p></div>
        <ol>{sportsClubAppChecks.map(([stage, title, copy]) => <li key={stage}><span>{stage}</span><div><h3>{title}</h3><p>{copy}</p></div></li>)}</ol>
      </section>
      <section className="sports-app-next" aria-labelledby="sports-app-next-title">
        <div><h2 id="sports-app-next-title">Try it before your club moves</h2><p>{sportsClubAppTrial}</p></div>
        <div><h3>Plans that grow with your club</h3><p>{sportsClubAppPlans}</p></div>
      </section>
      <section className="sports-app-fit" aria-labelledby="sports-app-fit-title">
        <h2 id="sports-app-fit-title">Is it the right app for your club?</h2>
        <p>{sportsClubAppChoose}</p>
        <nav aria-label="Related club guides">{sportsClubAppLinks.map(([href, label]) => <Link key={href} to={href}>{label} <span aria-hidden="true">→</span></Link>)}</nav>
      </section>
    </main>
  </>;
}
